    angular.module('service-request-integration', ['core'])
        .factory('ServiceRequestIntegration', function ($resource) {
            return  $resource('/crm/api/service-request-integration/:id', {id: "@id"}, {
                query: { isArray: false },
                statistics: { url: '/crm/api/service-request-integration/statistics', isArray: true },
            });
        })
        .component('serviceRequestIntegrationList', {
            bindings: {
                filters: '<',
                page: '<'
            },
            templateUrl: 'app/service-request/integration/list.html',
            controller: function ($scope, $state, $stateParams, ServiceRequestService, ServiceRequestConst) {
                this.ServiceRequestService = ServiceRequestService;
                this.reset = () => this.filters = {};
                $scope.$on(ServiceRequestConst.eventUpdate, () => $state.reload());

                this.getClaimantType = (text) => {
                    switch (text) {
                        case 'Osoba fizyczna':
                            return 'INDIVIDUAL';
                        case 'Wspólnota / Administracja':
                            return 'ORGANIZATION';
                        default:
                    }
                }

                this.addServiceRequestServiceForms = (item) => {

                    let source = {
                    }

                    source.claimantType = item.answers?.find(a => a.alias === 'client-type')?.answer
                    source.name = item.answers?.find(a => a.alias === 'name')?.answer
                    source.phone = item.answers?.find(a => a.alias === 'phone')?.answer
                    source.email = item.answers?.find(a => a.alias === 'email')?.answer
                    source.description = item.answers?.find(a => a.alias === 'description')?.answer

                    source.location = item.answers?.find(a => a.alias === 'location')?.answer
                    source.project = item.answers?.find(a => a.alias === 'project')?.answer?.find(i => i)
                    let address = item.answers?.find(a => a.alias === 'address')?.answer
                    let addressNumber = item.answers?.find(a => a.alias === 'address-number')?.answer
                    let addressApartment = item.answers?.find(a => a.alias === 'address-apartment')?.answer
                    source.address = [address, [addressNumber, addressApartment].join("/")].join(" ")

                    let categoryCzescWspolna = item.answers?.find(a => a.alias === 'category-czesc-wspolna')?.answer?.find(i => i)
                    let categoryLokal = item.answers?.find?.(a => a.alias === 'category-lokal')?.answer?.find(i => i)
                    source.category = categoryLokal || categoryCzescWspolna
                    source.transferDate = item.answers?.find(a => a.alias === 'transfer-date')?.answer
                    source.filledInAt = item.created_at

                    if(source.transferDate != null){
                        source.description = "Data odbioru lokalu: " + source.transferDate + "\n\n" + source.description
                    }

                    let req = {
                        filledInAt: source.filledInAt,
                        claimantType: this.getClaimantType(source.claimantType),
                        clientMessage: source.description,
                        subjectOfClaim: {
                            address: source.address
                        },
                        externalSource: {
                            system: 'EASYFORMS',
                            id: item.hashId
                        },
                        files: item.files.map(f => {
                            return {
                                name: f.name,
                                url: f.link,
                                size: f.size,
                            }
                        })
                        // category: source.category,
                    };
                    ServiceRequestService.add(req, source);
                }
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('serviceRequestIntegrationList', {
                parent: 'app',
                url: '/service-request-integration?{id}&{page:int}',
                data: {
                    authorities: ['ROLE_SERVICE_REQUEST']
                },
                views: {
                    'content@': 'serviceRequestIntegrationList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (ServiceRequestIntegration, $stateParams) => ServiceRequestIntegration.query(angular.copy($stateParams)).$promise
                }
            });
        });
